module.exports = __webpack_public_path__ + "img/header-shopify-img.511b661d.svg";